import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../dynamicFormBuilder/FormField'
import { UOMLayout } from "../Layout";
function UOMTab(props) {
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    var currentUser = props.oidc.user;
    const formRefs = useRef({});
    return (
        <div className="FormMt">
            <FormField
                currrentUser={currentUser}
                layoutId='4F75E225-9EC2-458B-9EF0-C53D6D32F308'
                layoutName='IMLotDataEntryUOMForm'
                defaultFormSchema={UOMLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={(name, value, e)=>props.handleFieldChange(name, value, e,formRefs)}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={formRefs}
                onFormLoad={()=>props.handleUOMFormLoad(formRefs)}
                handleSelectedItemChange={props.handleSelectionChange}
            />
        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(UOMTab);